@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package materialextension.multiplatform_material_extension.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi

private object CommonMainDrawable0 {
  public val ic24_mel_arrow_down: DrawableResource by 
      lazy { init_ic24_mel_arrow_down() }

  public val ic24_mel_calendar: DrawableResource by 
      lazy { init_ic24_mel_calendar() }

  public val ic24_mel_exit_circle: DrawableResource by 
      lazy { init_ic24_mel_exit_circle() }

  public val ic24_mel_eye_close: DrawableResource by 
      lazy { init_ic24_mel_eye_close() }

  public val ic24_mel_eye_open: DrawableResource by 
      lazy { init_ic24_mel_eye_open() }

  public val ic24_mel_search: DrawableResource by 
      lazy { init_ic24_mel_search() }

  public val mel_arrow_left: DrawableResource by 
      lazy { init_mel_arrow_left() }

  public val mel_arrow_right: DrawableResource by 
      lazy { init_mel_arrow_right() }

  public val mel_broom: DrawableResource by 
      lazy { init_mel_broom() }

  public val mel_hide_password: DrawableResource by 
      lazy { init_mel_hide_password() }

  public val mel_ic_calendar: DrawableResource by 
      lazy { init_mel_ic_calendar() }

  public val mel_ic_clear: DrawableResource by 
      lazy { init_mel_ic_clear() }

  public val mel_ic_down: DrawableResource by 
      lazy { init_mel_ic_down() }

  public val mel_ic_search: DrawableResource by 
      lazy { init_mel_ic_search() }

  public val mel_show_password: DrawableResource by 
      lazy { init_mel_show_password() }

  public val moon: DrawableResource by 
      lazy { init_moon() }

  public val sun: DrawableResource by 
      lazy { init_sun() }
}

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic24_mel_arrow_down", CommonMainDrawable0.ic24_mel_arrow_down)
  map.put("ic24_mel_calendar", CommonMainDrawable0.ic24_mel_calendar)
  map.put("ic24_mel_exit_circle", CommonMainDrawable0.ic24_mel_exit_circle)
  map.put("ic24_mel_eye_close", CommonMainDrawable0.ic24_mel_eye_close)
  map.put("ic24_mel_eye_open", CommonMainDrawable0.ic24_mel_eye_open)
  map.put("ic24_mel_search", CommonMainDrawable0.ic24_mel_search)
  map.put("mel_arrow_left", CommonMainDrawable0.mel_arrow_left)
  map.put("mel_arrow_right", CommonMainDrawable0.mel_arrow_right)
  map.put("mel_broom", CommonMainDrawable0.mel_broom)
  map.put("mel_hide_password", CommonMainDrawable0.mel_hide_password)
  map.put("mel_ic_calendar", CommonMainDrawable0.mel_ic_calendar)
  map.put("mel_ic_clear", CommonMainDrawable0.mel_ic_clear)
  map.put("mel_ic_down", CommonMainDrawable0.mel_ic_down)
  map.put("mel_ic_search", CommonMainDrawable0.mel_ic_search)
  map.put("mel_show_password", CommonMainDrawable0.mel_show_password)
  map.put("moon", CommonMainDrawable0.moon)
  map.put("sun", CommonMainDrawable0.sun)
}

internal val Res.drawable.ic24_mel_arrow_down: DrawableResource
  get() = CommonMainDrawable0.ic24_mel_arrow_down

private fun init_ic24_mel_arrow_down(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic24_mel_arrow_down",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/drawable/ic24_mel_arrow_down.xml", -1, -1),
    )
)

internal val Res.drawable.ic24_mel_calendar: DrawableResource
  get() = CommonMainDrawable0.ic24_mel_calendar

private fun init_ic24_mel_calendar(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic24_mel_calendar",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/drawable/ic24_mel_calendar.xml", -1, -1),
    )
)

internal val Res.drawable.ic24_mel_exit_circle: DrawableResource
  get() = CommonMainDrawable0.ic24_mel_exit_circle

private fun init_ic24_mel_exit_circle(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic24_mel_exit_circle",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/drawable/ic24_mel_exit_circle.xml", -1, -1),
    )
)

internal val Res.drawable.ic24_mel_eye_close: DrawableResource
  get() = CommonMainDrawable0.ic24_mel_eye_close

private fun init_ic24_mel_eye_close(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic24_mel_eye_close",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/drawable/ic24_mel_eye_close.xml", -1, -1),
    )
)

internal val Res.drawable.ic24_mel_eye_open: DrawableResource
  get() = CommonMainDrawable0.ic24_mel_eye_open

private fun init_ic24_mel_eye_open(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic24_mel_eye_open",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/drawable/ic24_mel_eye_open.xml", -1, -1),
    )
)

internal val Res.drawable.ic24_mel_search: DrawableResource
  get() = CommonMainDrawable0.ic24_mel_search

private fun init_ic24_mel_search(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic24_mel_search",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/drawable/ic24_mel_search.xml", -1, -1),
    )
)

internal val Res.drawable.mel_arrow_left: DrawableResource
  get() = CommonMainDrawable0.mel_arrow_left

private fun init_mel_arrow_left(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:mel_arrow_left",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/drawable/mel-arrow-left.xml", -1, -1),
    )
)

internal val Res.drawable.mel_arrow_right: DrawableResource
  get() = CommonMainDrawable0.mel_arrow_right

private fun init_mel_arrow_right(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:mel_arrow_right",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/drawable/mel-arrow-right.xml", -1, -1),
    )
)

internal val Res.drawable.mel_broom: DrawableResource
  get() = CommonMainDrawable0.mel_broom

private fun init_mel_broom(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:mel_broom",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/drawable/mel-broom.xml", -1, -1),
    )
)

internal val Res.drawable.mel_hide_password: DrawableResource
  get() = CommonMainDrawable0.mel_hide_password

private fun init_mel_hide_password(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:mel_hide_password",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/drawable/mel-hide-password.xml", -1, -1),
    )
)

internal val Res.drawable.mel_ic_calendar: DrawableResource
  get() = CommonMainDrawable0.mel_ic_calendar

private fun init_mel_ic_calendar(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:mel_ic_calendar",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/drawable/mel-ic-calendar.xml", -1, -1),
    )
)

internal val Res.drawable.mel_ic_clear: DrawableResource
  get() = CommonMainDrawable0.mel_ic_clear

private fun init_mel_ic_clear(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:mel_ic_clear",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/drawable/mel_ic_clear.xml", -1, -1),
    )
)

internal val Res.drawable.mel_ic_down: DrawableResource
  get() = CommonMainDrawable0.mel_ic_down

private fun init_mel_ic_down(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:mel_ic_down",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/drawable/mel-ic-down.xml", -1, -1),
    )
)

internal val Res.drawable.mel_ic_search: DrawableResource
  get() = CommonMainDrawable0.mel_ic_search

private fun init_mel_ic_search(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:mel_ic_search",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/drawable/mel_ic_search.xml", -1, -1),
    )
)

internal val Res.drawable.mel_show_password: DrawableResource
  get() = CommonMainDrawable0.mel_show_password

private fun init_mel_show_password(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:mel_show_password",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/drawable/mel-show-password.xml", -1, -1),
    )
)

internal val Res.drawable.moon: DrawableResource
  get() = CommonMainDrawable0.moon

private fun init_moon(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:moon",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/drawable/moon.xml", -1, -1),
    )
)

internal val Res.drawable.sun: DrawableResource
  get() = CommonMainDrawable0.sun

private fun init_sun(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:sun",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.multiplatform_material_extension.generated.resources/drawable/sun.xml", -1, -1),
    )
)
